import usePerformance from "./usePerformance";
import Folder from "../../assets/folder.png";
import LeaderBoard from "./leaderBoard";

const PerformanceTab = () => {
  const {
    testInfo,
    loadingData,
    state,
    handleCard,
    closeView,
    viewLeaderBoardHandler,
  } = usePerformance();
  return (
    <>
      <div className="grid gap-5 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 mt-10">
        {testInfo?.loading ? (
          loadingData?.map((_, i) => (
            <div
              key={i}
              className="animate-pulse h-32 bg-gray-200 rounded"
            ></div>
          ))
        ) : testInfo?.data?.length ? (
          testInfo?.data?.map((x) => (
            <div
              onClick={() => (x.Type === "Folder" ? handleCard(x) : {})}
              className="flex gap-2 w-full cursor-pointer rounded p-4 items-center bg-white shadow-md hover:shadow-lg transition duration-300 relative"
            >
              {x.Type === "Folder" ? (
                <img src={Folder} className="h-32" />
              ) : (
                <img src={x?.ImgIcon} className="h-32" />
              )}
              <div key={x?.objectId} className="flex flex-col gap-5 p-4 ">
                {/* Title and description */}
                <span className="text-xl font-bold text-blue-600">
                  {x?.TestTitle}
                </span>
                <span className="text-gray-700">{x?.TestDesc}</span>
                {x.Type !== "Folder" && (
                  <button
                    className="font-semibold text-green-500 underline"
                    onClick={() => viewLeaderBoardHandler(x)}
                  >
                    View Leaderboard
                  </button>
                )}
              </div>
            </div>
          ))
        ) : (
          <span className="font-semibold text-lg">no data found!</span>
        )}
      </div>
      {state.show && (
        <LeaderBoard data={state.view} open={state.show} onClose={closeView} />
      )}
    </>
  );
};

export default PerformanceTab;
